// extracted by mini-css-extract-plugin
module.exports = {"hook-form-input__annonymous-switch--mt":"HookFormInputsStyle_hook-form-input__annonymous-switch--mt__mN6jD"};